import { useEffect, useCallback } from 'react'
import { useSessionTimeout } from '~/hooks/useSessionTimeout'
import { sessionActivity } from '~/helpers/sessionActivity'

export const SessionTimeoutGuard = () => {
  const onSessionExpiring = useCallback(() => {
    // Navigate to sso_logout without id_token_hint so Keycloak shows
    // "Are you still there?" with the "Back to Dashboard" option
    window.location.replace('/sso_logout?redirect_url=/&skip_id_token_hint=1')
  }, [])

  const { resetTimer } = useSessionTimeout(onSessionExpiring)

  useEffect(() => {
    return sessionActivity.subscribe(resetTimer)
  }, [resetTimer])

  return null
}
